










































































import {Component, Vue} from 'vue-property-decorator';
import Page, {EMPTY_PAGE} from "@/dto/taxation/Page";
import {
	ServiceInvoice,
	ServiceInvoiceFilter, ServiceRecordDTO,
	UpdateInvoicePayload
} from "@/components/payroll/business/services/ServiceDTO";
import ServiceInvoiceOrchestrator from "@/services/ServiceInvoiceOrchestrator";
import {processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import InvoiceCreationSlider from "@/components/payroll/business/services/invoice/InvoiceCreationSlider.vue";
import EmbeddedFile from "@/components/common/EmbeddedFile.vue";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import moment from "moment";
import {prettyEnum, subSrtIfNeed} from "../../../../../utils/StringUtils";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import ServiceLogView from "@/components/payroll/business/services/ServiceLogView.vue";
import ServiceInvoiceItem from "@/components/payroll/business/services/ServiceInvoiceItem.vue";
import DraftInvoicePreparer from "@/components/payroll/business/services/invoice/DraftInvoicePreparer.vue";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import ServiceLogUpdateSlider from "@/components/payroll/business/services/service/ServiceLogUpdateSlider.vue";
import ServiceLogViewSlider from "@/components/payroll/business/services/service/ServiceLogViewSlider.vue";
import BillCreationSlider from "@/components/payroll/business/services/bills/BillCreationSlider.vue";
import BillCollapse from "@/components/payroll/business/services/bills/BillCollapse.vue";
import InvoiceService from "@/services/InvoiceService";
import InvoiceDTO from "@/dto/InvoiceDTO";

@Component({
	methods: {prettyEnum, subSrtIfNeed},
	components: {
		BillCollapse,
		BillCreationSlider,
		ServiceLogViewSlider,
		ServiceLogUpdateSlider,
		PaginationComponent,
		DraftInvoicePreparer,
		ServiceInvoiceItem,
		ServiceLogView, SingleFileHolder, BTPortalCollapse, EmbeddedFile, InvoiceCreationSlider}
})
export default class InvoiceList extends Vue {

	private draftInvoices: Page<ServiceInvoice> = EMPTY_PAGE
	private invoices: Page<ServiceInvoice> = EMPTY_PAGE

	private createInvoice = false;
	private draftInvoice = false
	private updateLog = false;
	private viewLog = false;

	private selectedInvoice: ServiceInvoice | null = null;
	private selectedLog: ServiceRecordDTO | null = null;

	private filter = new ServiceInvoiceFilter(
		{
			payerId: this.$wss.getCurrent.id
		}
	)

	openDraft(inv: ServiceInvoice) {
		this.selectedInvoice = inv
		this.draftInvoice = true
	}

	mounted() {
		Application.startLoading()
		Promise.all([this.loadInvoices()])
			.finally(Application.stopLoading)
	}

	findInvoices() {
		Application.startLoading()
		Promise.all([this.loadInvoices()])
			.finally(Application.stopLoading)
		this.$emit("reload")
	}

	private deleteDraftInvoice(inv: ServiceInvoice): void {
		Application.startLoading()
		ServiceInvoiceOrchestrator.deleteDraftInvoice(inv.id).then(
			() => this.findInvoices(),
			err => processError(err, this)
		)
	}

	loadInvoices() {
		let filter = new ServiceInvoiceFilter(this.filter)
		filter.excludeStatus = "DRAFT"
		filter.size = 10
		return InvoiceService.getPageByFilter(filter).then(
			res => {
				this.invoices = res.data
			},
			err => processError(err, this)
		)
	}

	private loadPage(page: number) {
		this.filter.page = page - 1
		this.findInvoices()
	}

	private loadNextPage() {
		this.filter.page = this.filter.page + 1
		this.findInvoices()
	}

	private voidInvoice(inv: InvoiceDTO<any>) {
		Application.startLoading()
		InvoiceService.decline(inv.id).then(
			() => {
				this.findInvoices()
			},
			err => processError(err, this)
		).finally(() => Application.stopLoading())
	}

	private completeInvoice(inv: InvoiceDTO<any>) {
		Application.startLoading()
		InvoiceService.complete(inv.id).then(
			() => {
				this.findInvoices()
			},
			err => processError(err, this)
		).finally(() => Application.stopLoading())
	}

	private openLog(log: ServiceRecordDTO, draft: boolean) {
		this.selectedLog = log
		if (!draft) {
			this.viewLog = true;
		} else {
			this.updateLog = true;
		}
	}

}
